import * as React from "react"
import {Box, Typography} from "@mui/material";


export default function LabelValueText({ label, value }) {
	return <Typography variant="caption" sx={{ display: 'flex', verticalAlign: 'center' }}>
		<Box component="span" color="text.disabled" sx={{ mr: .5 }}>
			{label}:
		</Box>
		{value}
	</Typography>
}